import {
  getURL,
} from '@/nms/plugins/bridge.js'
const baseURL = getURL('bridge')

//LocalServiceWorkerRegister(); вызвать в index
let subscription = null;

//Получение данных для создания подписки
export const getSubscription = () => {return subscription}

//Публичный ключ сервера
const publicVapidKey = 'BGkV7dGv5OoDVcBmDj8Pk-VQC1wTb4XiZRUGbvIpE6TzqGlvOuDsl49AyIcgLg7msNDJiIUOSHSV8ehhVs6PKBg';

//Регистрация сервис воркера
export default async function LocalServiceWorkerRegister() {
  console.log('starting service worker registering');
  console.log('navigator', navigator)
  if ('serviceWorker' in navigator) {
  console.log('Registering service worker');

  const registration = await navigator.serviceWorker.register('../../../static/sw.js');
  console.log('Registered service worker', registration);

  //Сбор данных сервисворкера для создания подписки
  subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
    });
  }
}

//Вспомогательная функция для создания подписки
function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}